import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  get_loggedin_user_meta_data_action,
  update_company_details_hiring_manager_action,
  update_user_meta_data_action,
  update_user_timezone_action,
} from "../../../redux/_actions";

function useHiringManagerProfile(props) {
  const [loading, setLoading] = useState(false);
  const [companyDetails, setCompanyDetails] = useState({});
  const [userData, setUserData] = useState({});
  const [formData, setFormData] = useState({});
  const [formInputsError, setFormInputsError] = useState({});
  const [error, setError] = useState("");

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { companyData } = useSelector(
    (state) => state.get_company_details_hiring_manager_reduer
  );
  const { loggedInMetaData } = useSelector((state) => state.get_loggedin_user_meta_data_reducer);


  useEffect(() => {
    callUserMetaApi();
  }, []);

  useEffect(() => {
    if (loggedInMetaData?.data) {
      setUserData(loggedInMetaData?.data);
    }
  }, [loggedInMetaData]);

  useEffect(() => {
    if (companyData?.data) {
      setCompanyDetails(companyData?.data);
    }
  }, [companyData]);

  const callUserMetaApi = async () => {
    await dispatch(get_loggedin_user_meta_data_action());
  };

  const onInpuBlur = async (value, name) => {
    let data = {};
    data[name] = value;
    await dispatch(
      update_company_details_hiring_manager_action(companyDetails?.id, data)
    );
  };

  const getHtmlData = async (htmlData, key) => {
    let data = formData;
    data[key] = htmlData;
    setFormData(data);
  };

  const onImageUpload = async (e) => {
    const file = e.target.files[0];
    const data = new FormData();
    data.append("logo", file);
    await dispatch(
      update_company_details_hiring_manager_action(companyDetails?.id, data)
    );
  };

  const onSaveClick = async () => {
    await dispatch(
      update_company_details_hiring_manager_action(companyDetails?.id, formData)
    );
  };

  const onCreateJobsClick = async () => {
    navigate("/create-job");
  };

  const onProfileImageUpload = async (e, key) => {
    const file = e.target.files[0];
    const name = e.target.name;
    const data = new FormData();

    data.append(name, file);
    if (file) {
      await dispatch(update_user_meta_data_action(data));
      await dispatch(get_loggedin_user_meta_data_action());
    }

  };

  const onProfileInputBlur = async (value, name) => {
    let data = {};
    data[name] = value;
    await dispatch(
      update_user_meta_data_action(data));
    await dispatch(get_loggedin_user_meta_data_action());

  };

  const onTimeZoneChange = async (e) => {
    let value = e.target.value;
    let name = e.target.name;
    let data = {};
    data[name] = value;
    await dispatch(update_user_timezone_action(data));
    await dispatch(get_loggedin_user_meta_data_action());
  };

  return {
    loading,
    companyDetails,
    userData,
    formInputsError,
    error,
    getHtmlData,
    onSaveClick,
    onImageUpload,
    onCreateJobsClick,
    onInpuBlur,
    onProfileInputBlur,
    onProfileImageUpload,
    onTimeZoneChange
  };
}
export default useHiringManagerProfile;
